module.exports = __webpack_public_path__ + "img/bank-left.5f03e0b5.png";